import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as KnowEachOtherArtBottomSvg } from '../../assets/know_each_other/art_bottom.svg';
import { ReactComponent as PlexBrandingSvg } from '../../assets/plex_branding.svg';
import { spacings, TextSizesEnum } from '../../theme';
import { SharedNavBar } from '../shared/navigation/SharedNavBar';
import { PlexTypography } from '../shared/primitives/PlexTypography';

type Props = {
  message: string;
  showNavbar?: boolean;
};

export function GenericErrorPage({ showNavbar, message }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <>
      {showNavbar && (
        <SharedNavBar>
          <Link to="/" className={classes.plexLogo}>
            <PlexBrandingSvg />
          </Link>
        </SharedNavBar>
      )}
      <div className={classes.content}>
        <PlexTypography className={classes.artTitle} text={message} size={TextSizesEnum.XLarge} />
        <div className={classes.artContainer}>
          <KnowEachOtherArtBottomSvg className={classes.art} />
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  plexLogo: {
    flexShrink: 0,
    width: 260,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: spacings.xlarge,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  art: {
    marginTop: spacings.small,
    transform: 'scale(1.5)',
    willChange: 'transform', // smoother scroll (GPU driven)
  },
  artContainer: {
    marginTop: 80,
  },
  artTitle: {
    color: '#464663',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: spacings.xlarge,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    overflowX: 'auto',
    height: '100vh',
    width: '100%',
    paddingTop: 80,
    backgroundColor: '#F6F6F6',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
}));
